import React, { useState, useEffect } from "react"
import { CardText, Col, Row, Alert, Label } from "reactstrap"

import DPTextBox from "../../../framework/components/DPTextBox"
import DPSwitch from "framework/components/DPSwitch"
import DPDropDown from "framework/components/DPDropDown"
import DBRadioButtonNew from "framework/components/DBRadioButtonNew"

const CustomerMasterTab5 = ({
  fieldManager,
  LoyalVlaue,
  LoyalOnChange,
  LoyalCatValue,
  LoyalCatOnChange,
  OpenPointValue,
  OpenPontOnChange,
  FDisValue,
  FDisOnChange,
  PreLanValue,
  PreLanOnChange,
  EBillValue,
  EBillOnChange,
  REmailValue,
  REmailOnChange,
  RSMSVlaue,
  RSMSOnChange,
  MobileVlaue,
  MobileOnChange,
  Disabled,
  show,
  AlertMsg,
  AlertColor,
  DisGroupValue,
  DisGroupOnChange,
  OpenPoint,
  discountOnBlur,
  openPointOnBlur,
  loyaltyPoints
}) => {

  const [loyalty, SetLoyalty] = useState([])
  const [discount, SetDiscount] = useState([])
  const [language, SetLanguage] = useState([])

  const radio = [{ label: "Active", value: 1 }, { label: " Inactive", value: 0 }]

  useEffect(() => {
    const authToken = localStorage.getItem("authToken")
    /**************get loyalty data */
    function getLoyalty() {
      var requestOptions = {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}LoyaltyGroup/Select/`, requestOptions)
        .then(response => response.json())
        .then(result => {
          SetLoyalty(result.data)
          let dt = result.data

        }).catch(error => console.log('error', error));
    }
    /**************get loyalty data  End*/

    /**************get Discount data */
    function getDiscount() {

      var requestOptions = {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}CustomerDiscGroup/Select/`, requestOptions)
        .then(response => response.json())
        .then(result => {
          SetDiscount(result.data)
          let dt = result.data

        }).catch(error => console.log('error', error));
    }
    /**************get Discount data End*/

    /**************get Language data */
    function getLanguage() {
      var requestOptions = {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}Language/Select/`, requestOptions)
        .then(response => response.json())
        .then(result => {
          SetLanguage(result.data)
          let dt = result.data

        }).catch(error => console.log('error', error));
    }
    /**************get Language data End*/

    getLoyalty()
    getDiscount()
    getLanguage()

  }, []);


  return (
    <React.Fragment>
      <div>
        <Row>
          <Col sm="12">
            <CardText className="mb-0">
              <Row>
                {show ? (
                  <Alert color={AlertColor} role="alert">
                    {AlertMsg}
                  </Alert>
                ) : null}
                <Col sm={12} md={8} className="mb-4-sm">

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_LOYALTY')}>
                    <DBRadioButtonNew
                      rowClass="mb-4-sm"
                      labelText="Loyalty Status"
                      types={radio}
                      OnChange={LoyalOnChange}
                      value={LoyalVlaue}
                      Disabled={Disabled || fieldManager.disable.includes('CM_LOYALTY')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_LOYGROUP')}>
                    <DPDropDown
                      labelText="Loyalty Category"
                      rowClass="mb-4-sm"
                      optionGroup={loyalty}
                      selectedGroup={LoyalCatValue}
                      onChange={LoyalCatOnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_LOYGROUP')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_OP_POINTS')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Opening point"
                      textType="text"
                      defaultValue="0"
                      textAlign="right"
                      value={OpenPointValue}
                      onChange={OpenPontOnChange}
                      onBlur={openPointOnBlur}
                      disabled={Disabled == true ? Disabled : OpenPoint || fieldManager.disable.includes('CM_OP_POINTS')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_DISC')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Fix Discount %"
                      textType="text"
                      defaultValue="0"
                      disabled={Disabled || fieldManager.disable.includes('CM_DISC')}
                      textAlign="right"
                      value={FDisValue}
                      onBlur={discountOnBlur}
                      onChange={FDisOnChange}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_DISCGROUP')}>
                    <DPDropDown
                      labelText="Discount Group"
                      rowClass="mb-4-sm"
                      optionGroup={discount}
                      selectedGroup={DisGroupValue}
                      onChange={DisGroupOnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_DISCGROUP')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_LANGUAGE')}>
                    <DPDropDown
                      labelText="Prefered Language"
                      rowClass="mb-4-sm"
                      optionGroup={language}
                      selectedGroup={PreLanValue}
                      onChange={PreLanOnChange}
                      disabled={Disabled || fieldManager.disable.includes('CM_LANGUAGE')}
                    />
                  </div>
                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_LOYALTYPOINTS')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Loyalty Points"
                      textType="text"
                      textAlign="right"
                      disabled={true}
                      value={loyaltyPoints}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_EBILL')}>
                    <Row>
                      <Col sm={3}>
                        <Label
                          htmlFor="example-text-input"
                          className={`col-md-12 col-form-label-sm`}
                        >
                          Send E-Bills
                        </Label>
                      </Col>
                      <Col >
                        <DPSwitch
                          rowClass={"mb-4-sm"}
                          onChange={EBillOnChange}
                          checked={EBillValue}
                          disabled={Disabled || fieldManager.disable.includes('CM_EBILL')}
                        />
                      </Col>
                    </Row>
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_PROMOEMAIL')}>
                    <Row>
                      <Col sm={3}>
                        <Label
                          htmlFor="example-text-input"
                          className={`col-md-12 col-form-label-sm`}
                        >
                          Receive promotional Email
                        </Label>
                      </Col>
                      <Col >
                        <DPSwitch
                          rowClass={"mb-4-sm"}
                          onChange={REmailOnChange}
                          checked={REmailValue}
                          disabled={Disabled || fieldManager.disable.includes('CM_PROMOEMAIL')}
                        />
                      </Col>
                    </Row>
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_PROMOSMS')}>
                    <Row>
                      <Col sm={3}>
                        <Label
                          htmlFor="example-text-input"
                          className={`col-md-12 col-form-label-sm`}
                        >
                          Receive promotional SMS
                        </Label></Col>
                      <Col >
                        <DPSwitch
                          rowClass={"mb-4-sm"}
                          onChange={RSMSOnChange}
                          checked={RSMSVlaue}
                          disabled={Disabled || fieldManager.disable.includes('CM_PROMOSMS')}
                        />
                      </Col>
                    </Row>
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('CM_APPUSER')}>
                    <Row>
                      <Col sm={3}>
                        <Label
                          htmlFor="example-text-input"
                          className={`col-md-12 col-form-label-sm`}
                        >
                          Mobile app user
                        </Label>
                      </Col>
                      <Col >
                        <DPSwitch
                          rowClass={"mb-4-sm"}
                          onChange={MobileOnChange}
                          checked={MobileVlaue}
                          disabled={Disabled || fieldManager.disable.includes('CM_APPUSER')}
                        />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </CardText>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}
export default CustomerMasterTab5
